// eslint-disable-next-line import/prefer-default-export
export const ImportWorkplanSteps = Object.freeze({
    Loading: -1,
    DeletePreviousShiftLines: 0,
    InsertNewShiftLines: 1,
    WrappingUp: 2,
});
